import { PERSONAL_WORKSPACE_ID } from '@store/reducers/dashboard/constants'
import { selectTemplates } from '@store/reducers/templates'
import { useSelector } from 'react-redux'

import { isPaidPlan } from '@/constants/userSubscriptionPlans'
import { useAuth } from '@/hooks'
import { useWorkspaces } from '../../../hooks'
import {
  GALLERY_TEMPLATE_FEATURES,
  OWN_TEMPLATE_FEATURES,
  toProjectItem,
} from '../utils'

// The fetch itself lives in the dashboard layout (useTemplatesPrefetch); this
// hook only reads what has arrived for the current workspace.
export const useTemplates = () => {
  const { workspaceId } = useWorkspaces()

  const { planId } = useAuth()

  const templates = useSelector(selectTemplates)

  // Lists from another workspace are not shown while the fresh ones load.
  const ready = templates.workspaceId === workspaceId

  const own = ready
    ? templates.own.map((template) =>
        toProjectItem(template, OWN_TEMPLATE_FEATURES)
      )
    : []
  const shared = ready
    ? templates.shared.map((template) =>
        toProjectItem(template, GALLERY_TEMPLATE_FEATURES)
      )
    : []

  // Own templates are a paid feature in the personal workspace. In a team
  // workspace membership is enough — the team's plan covers everyone in it.
  const upsell = workspaceId === PERSONAL_WORKSPACE_ID && !isPaidPlan(planId)

  return { own, shared, ready, upsell }
}
